var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-side-bar"},[_c('a',{staticClass:"item f-c-c",attrs:{"href":"https://w1022.ttkefu.com/k/linkurl/?t=2J9DDJ4","target":"_blank"}},[_c('div',[_vm._v("联系")]),_c('div',[_vm._v("客服")])])])
}]

export { render, staticRenderFns }